import { render, staticRenderFns } from "./LayoutConfigPanel.vue?vue&type=template&id=74bfdcdc&scoped=true&"
import script from "./LayoutConfigPanel.vue?vue&type=script&lang=js&"
export * from "./LayoutConfigPanel.vue?vue&type=script&lang=js&"
import style0 from "./LayoutConfigPanel.vue?vue&type=style&index=0&id=74bfdcdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfdcdc",
  null
  
)

export default component.exports